export const ROWS_BUFFER_DEFAULT = 20;
export const ROW_HEIGHT_MIN = 35;
